module.exports = __webpack_public_path__ + "images/imagebetter2.76c63524.png";